import { dataHooks } from '@wix/data-hooks'

export const storesFunnelBusinessNameDataHooks = dataHooks<{
  back: {}
  skip: {}
  next: {}
  stepProgressBar: {}
  title: {}
  subtitle: {}
  input: {}
}>('stores-funnel-business-name')
